module.exports = __webpack_public_path__ + "static/media/index.dae098fc.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Grid/index.md
// module id = 190
// module chunks = 0